export const REPORTING_BOUNDARY_ENDPOINTS = {
  REPORTING_BOUNDARY: "/reporting-boundary",
  FRAMEWORKS: "/frameworks",
  REPORTING_YEARS: "/reporting-boundary/reporting-years",
  REPORTING_YEARS_LIST: "/reporting-boundary/reporting-years-list",
  REPORTING_YEAR_DETAIL: (id) => `/reporting-boundary/${id}`,
};
